import { issueWorkflowSource } from 'serviceWorker/services/issueWorkflows/issueWorkflowSource';
import { queueWorkflowChanges } from 'serviceWorker/services/workflows/queueWorkflowChanges';
import { channelServer, ChannelUnsubscribe } from 'shared/channels';
import { workflowContract } from 'shared/domain/workflow/workflowContract';
import { serveEntityRequests } from './serveEntityRequests';

/** Answers the workflow requests: the list, and changes answered once queued. */
export function serveWorkflowRequests(): ChannelUnsubscribe {
  const unsubscribes = [
    serveEntityRequests(workflowContract, issueWorkflowSource),
    channelServer.handle(workflowContract, queueWorkflowChanges),
  ];
  return () => unsubscribes.forEach((unsubscribe) => unsubscribe());
}
